import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Account } from '../state/types';
import UserAccountInfo from '../components/authentication/UserAccountInfo';
import AccountsTable from '../components/authentication/AccountsTable';
import AccountModal from '../components/authentication/AccountModal';
import ChangePasswordModal from '../components/authentication/ChangePasswordModal'; // ✅ Import Change Password Modal
import RoleBasedAccess from '../services/RoleBasedAccess';

const AccountPage: React.FC = () => {
  const [showSignUp, setShowSignUp] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<Account | null>(null);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false); // ✅ State for Change Password Modal

  const handleUserAddedOrUpdated = async () => {
    setSelectedAccount(null);
    setShowSignUp(false);
  };

  const openAddAccountModal = () => {
    setSelectedAccount(null);
    setShowSignUp(true);
  };

  const openEditAccountModal = (account: Account) => {
    setSelectedAccount(account);
    setShowSignUp(true);
  };

  return (
    <Box sx={{ 
      padding: 2,
      height: 'calc(100vh - 64px)', 
      overflow: 'none' 
      }}>
      {/* ✅ Pass function to UserAccountInfo to open Change Password Modal */}
      <UserAccountInfo
        openEditAccountModal={openEditAccountModal}
        openChangePasswordModal={() => setIsChangePasswordOpen(true)}
      />

      <AccountModal open={showSignUp} onClose={handleUserAddedOrUpdated} account={selectedAccount} />


      <RoleBasedAccess allowedRoles={["Admin", "Support"]}>
        <AccountsTable
          openEditAccountModal={openEditAccountModal}
          openAddAccountModal={openAddAccountModal}
        />
      </RoleBasedAccess>

      {/* ✅ Change Password Modal */}
      <ChangePasswordModal
        open={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </Box>
  );
};

export default AccountPage;
